import { Client, type Room } from "@colyseus/sdk";
import type { CrewState, JoinOptions, NoticeMessage } from "@wearecrew/shared";

const endpoint =
  import.meta.env.VITE_SERVER_URL ||
  (window.location.hostname === "localhost" && window.location.port === "5173"
    ? "http://localhost:3200"
    : window.location.origin);

export type CrewRoomConnection = Room<CrewState>;

export class CrewNetwork {
  readonly client = new Client(endpoint);

  createPrivate(name: string): Promise<CrewRoomConnection> {
    return this.client.create<CrewState>("crew", {
      name,
      visibility: "private"
    } satisfies JoinOptions);
  }

  quickPlay(name: string): Promise<CrewRoomConnection> {
    return this.client.joinOrCreate<CrewState>("crew", {
      name,
      visibility: "public"
    } satisfies JoinOptions);
  }

  joinByCode(roomId: string, name: string): Promise<CrewRoomConnection> {
    return this.client.joinById<CrewState>(roomId, { name } satisfies JoinOptions);
  }

  reconnect(token: string): Promise<CrewRoomConnection> {
    return this.client.reconnect<CrewState>(token);
  }
}

export type NoticeHandler = (notice: NoticeMessage) => void;

